var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "auto" } },
    [
      _c("section", { staticClass: "modal-card-body section" }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "button is-warning is-outlined is-small",
                on: { click: _vm.close },
              },
              [
                _c("b-icon", { attrs: { icon: "chevron-left" } }),
                _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "has-text-centered" }, [
          _c("h1", { staticClass: "title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("pages.pickup_management.signature.title")) +
                " "
            ),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.selectedGroup.collectGroup))]),
        ]),
        _vm.selectedGroup
          ? _c(
              "div",
              { staticClass: "section" },
              [
                _c("ValidationObserver", {
                  ref: "observer",
                  attrs: { tag: "form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ valid }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "container f-row f-center" },
                              [
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.first_name"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "firstname",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.signature.firstname,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "firstname",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "signature.firstname",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-left m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.last_name"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "lastname",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.signature.lastname,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "lastname",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "signature.lastname",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-left m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.job"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "job",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value: _vm.signature.job,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "job",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "signature.job",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-left m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.phone"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "phone",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value: _vm.signature.phone,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "phone",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "signature.phone",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "container f-row f-center" },
                              [
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.address"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "address",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.signature.address,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "address",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "signature.address",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-left m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.postal_code"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "postalCode",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.signature.postalCode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "postalCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "signature.postalCode",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-left m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.city"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "city",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value: _vm.signature.city,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "city",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "signature.city",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    staticClass: "m-left m-right",
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.signature.country"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "country",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.signature.country,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.signature,
                                                        "country",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "signature.country",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("h1", { staticClass: "subtitle m-top" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.pickup_management.signature.preview"
                                    )
                                  ) +
                                  " : "
                              ),
                            ]),
                            _c("signaturePreview", {
                              attrs: { signature: _vm.signature },
                            }),
                            _c("div", { staticClass: "f-center m-top" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "is-primary button",
                                  attrs: { type: "submit" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("global.submit")) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4206015953
                  ),
                }),
                _c("div", { staticClass: "f-center m-top" }, [
                  _vm.existingSignature
                    ? _c(
                        "button",
                        {
                          staticClass: "is-danger button",
                          on: { click: _vm.remove },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.remove")) + " ")]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }